module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-2.e3cbe41e.png";